// utilities/seo-lookup.js

export const LOOKUP_SEO = {
  NY: {
    title: 'Lookup New York City Traffic Tickets | WinIt',
    description: 'Search for your New York City traffic tickets by license plate or ticket number. Fight tickets online — attorneys start at $99.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/new-york',
  },
  NY_STATE: {
    title: 'Lookup New York State Traffic Tickets | WinIt',
    description: 'Find and dispute New York State traffic violations in minutes. No court appearances required. Attorneys from $99.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/new-york-state',
  },
  NY_NASSAU: {
    title: 'Lookup Nassau County Traffic Tickets | WinIt',
    description: 'Search Nassau County traffic tickets by plate or case number. Fight your ticket with an attorney — free consultation.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/nassau',
  },
  NY_SUFFOLK: {
    title: 'Lookup Suffolk County Traffic Tickets | WinIt',
    description: 'Find Suffolk County traffic violations online. Dispute tickets easily with WinIt — no court appearances needed.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/suffolk',
  },
  NY_WESTCHESTER: {
    title: 'Lookup Westchester Traffic Tickets | WinIt',
    description: 'Search Westchester traffic tickets instantly. Fight violations with experienced attorneys starting at $99.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/westchester',
  },
  NJ: {
    title: 'Lookup New Jersey Traffic Tickets | WinIt',
    description: 'Search New Jersey traffic ticket records by license plate. Dispute violations with WinIt Law — attorneys from $99.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/new-jersey',
  },
  CAL: {
    title: 'Lookup Los Angeles Traffic Tickets | WinIt',
    description: 'Find your Los Angeles traffic tickets instantly. Contest tickets online with WinIt — no court visit needed.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/los-angeles',
  },
  CAL_STATE: {
    title: 'Lookup California Traffic Tickets | WinIt',
    description: 'Search California traffic violations by plate number. Fight tickets statewide with experienced WinIt attorneys.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/california',
  },
  CAL_SAN_FRANCISCO: {
    title: 'Lookup San Francisco Traffic Tickets | WinIt',
    description: 'Search San Francisco traffic tickets by plate. Fight violations with WinIt — attorneys start at $99.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/san-francisco',
  },
  CAL_ORANGE: {
    title: 'Lookup Orange County Traffic Tickets | WinIt',
    description: 'Find Orange County traffic ticket records. Contest violations online with WinIt Law.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/orange',
  },
  GA: {
    title: 'Lookup Georgia Traffic Tickets | WinIt',
    description: 'Search Georgia traffic violations by license plate. Dispute tickets with WinIt attorneys — no court appearances.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/georgia',
  },
  FL_MIAMI: {
    title: 'Lookup Miami Traffic Tickets | WinIt',
    description: 'Find Miami-Dade traffic tickets instantly. Fight violations with WinIt — attorneys from $99.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/miami',
  },
  TX_AUSTIN: {
    title: 'Lookup Austin Traffic Tickets | WinIt',
    description: 'Search Austin traffic ticket records by plate. Contest violations with WinIt Law.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/austin',
  },
  TX: {
    title: 'Lookup Texas Traffic Tickets | WinIt',
    description: 'Search Texas traffic ticket records across Austin, Dallas and Harris County courts. Contest violations with WinIt Law.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/texas',
  },
  PA_PHILADELPHIA: {
    title: 'Lookup Pennsylvania Traffic Tickets | WinIt',
    description: 'Find Pennsylvania traffic violations online. Fight tickets with WinIt Law attorneys — free case review.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/pennsylvania',
  },
  NC: {
    title: 'Lookup North Carolina Traffic Tickets | WinIt',
    description: 'Search North Carolina traffic ticket records. Dispute violations with experienced WinIt attorneys.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/north-carolina',
  },
  WA: {
    title: 'Lookup Washington Traffic Tickets | WinIt',
    description: 'Find Washington State traffic violations by plate. Fight tickets online with WinIt Law.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/washington',
  },
  WA_NEW_SEATTLE: {
    title: 'Lookup Seattle Traffic Tickets | WinIt',
    description: 'Search Seattle traffic ticket records instantly. Contest violations with WinIt — no court appearances needed.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/new-seattle',
  },
  VA: {
    title: 'Lookup Virginia Traffic Tickets | WinIt',
    description: 'Find Virginia traffic violations by license plate. Fight your ticket with WinIt Law attorneys from $99.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/virginia',
  },
  CAL_SAN_DIEGO: {
    title: 'Lookup San Diego Traffic Tickets | WinIt',
    description: 'Search San Diego traffic violations by license plate. Fight tickets online with WinIt Law.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/san-diego',
  },
  CAL_VENTURA: {
    title: 'Lookup Ventura County Traffic Tickets | WinIt',
    description: 'Find Ventura County traffic ticket records. Dispute violations with WinIt attorneys.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/ventura',
  },
  CAL_SAN_BERNARDINO: {
    title: 'Lookup San Bernardino Traffic Tickets | WinIt',
    description: 'Search San Bernardino traffic violations by plate. Fight tickets with WinIt Law.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/san-bernardino',
  },
  CAL_SANTA_BARBARA: {
    title: 'Lookup Santa Barbara Traffic Tickets | WinIt',
    description: 'Find Santa Barbara County traffic ticket records. Contest violations with WinIt attorneys.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/santa-barbara',
  },
  CAL_SAN_JOAQUIN: {
    title: 'Lookup San Joaquin Traffic Tickets | WinIt',
    description: 'Search San Joaquin traffic violations by license plate. Fight tickets with WinIt Law.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/san-joaquin',
  },
  NY_HEMPSTEAD: {
    title: 'Lookup Hempstead Traffic Tickets | WinIt',
    description: 'Find Hempstead traffic ticket records. Dispute violations with WinIt attorneys — no court appearances.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/hempstead',
  },
  NY_CRIMINAL: {
    title: 'Lookup New York Criminal Traffic Summons | WinIt',
    description: 'Search New York criminal traffic summons records. Fight your summons with experienced WinIt attorneys.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/new-york-criminal',
  },
  CAL_SANTA_CLARA: {
    title: 'Lookup Santa Clara Traffic Tickets | WinIt',
    description: 'Search Santa Clara County traffic violations by plate. Fight tickets with WinIt Law attorneys.',
    canonical: 'https://www.trafficviolations.info/traffic/lookup/santa-clara',
  },
}

export const DEFAULT_LOOKUP_SEO = {
  title: 'Lookup Your Traffic Tickets | WinIt',
  description: 'Search for traffic tickets by license plate and dispute violations online. WinIt attorneys start at $99 — no court appearances required.',
  canonical: 'https://www.trafficviolations.info/traffic/lookup',
}
